import { ShieldCheck, Leaf, Award, Package } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Lab-Tested", sub: "Every batch" },
  { icon: Leaf, label: "100% Pure", sub: "No additives" },
  { icon: Award, label: "45-Day Guarantee", sub: "Risk-free" },
  { icon: Package, label: "DHL Express", sub: "Ships from Borneo" },
];

export default function TrustBadges() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-testid="trust-badges">
      {items.map(({ icon: Icon, label, sub }) => (
        <div key={label} className="flex flex-col items-center text-center p-6 border border-white/5 bg-[#0D120E]">
          <Icon size={22} className="text-[#C8A97E] mb-3" strokeWidth={1.5} />
          <div className="text-sm font-medium text-[#F4F1ED]">{label}</div>
          <div className="text-xs text-[#75726D] mt-1">{sub}</div>
        </div>
      ))}
    </div>
  );
}
